import { render } from "./ProgramsDetailView.vue?vue&type=template&id=2172d24a&scoped=true"
import script from "./ProgramsDetailView.vue?vue&type=script&lang=js"
export * from "./ProgramsDetailView.vue?vue&type=script&lang=js"

import "./ProgramsDetailView.vue?vue&type=style&index=0&id=2172d24a&scoped=true&lang=scss"

import exportComponent from "/Users/macbook/Documents/personal/freelance-sabdulla/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2172d24a"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QCard,QCardSection,QSeparator,QCardActions});
